/**
 * Utility functions for favorite projects component
 */

import { ProjectModel } from '../../../mobx/models/project';
import { REORDER_INDEX_GAP } from '../../../global/constants';

/**
 * Calculates the updated task index for drag and drop reordering
 * @param destinationIndex - The destination index where item is dropped
 * @param sourceIndex - The source index where item was dragged from
 * @param favoriteProjects - Array of favorite projects with their current indices
 * @returns The calculated index for the reordered item
 */
export const calculateUpdatedTaskIndex = (
  destinationIndex: number,
  sourceIndex: number,
  favoriteProjects: ProjectModel[]
): number => {
  let updatedTaskIndex;

  if (destinationIndex === 0) {
    const nextTaskIndex = favoriteProjects?.[0]?.index;
    updatedTaskIndex = nextTaskIndex ? nextTaskIndex - REORDER_INDEX_GAP : new Date().getTime();
  } else if (destinationIndex === favoriteProjects?.length - 1) {
    const previousTaskIndex = favoriteProjects?.[favoriteProjects?.length - 1]?.index;
    updatedTaskIndex = previousTaskIndex ? previousTaskIndex + REORDER_INDEX_GAP : new Date().getTime();
  } else {
    if (destinationIndex > sourceIndex) {
      const previousTaskIndex: number = favoriteProjects?.[destinationIndex]?.index || 0;
      const nextTaskIndex: number = favoriteProjects?.[destinationIndex + 1]?.index || 0;
      updatedTaskIndex = (previousTaskIndex + nextTaskIndex) / 2;
    } else {
      const previousTaskIndex: number = favoriteProjects?.[destinationIndex - 1]?.index || 0;
      const nextTaskIndex: number = favoriteProjects?.[destinationIndex]?.index || 0;
      updatedTaskIndex = (previousTaskIndex + nextTaskIndex) / 2;
    }
  }

  return updatedTaskIndex;
};
